import { logoUrlFromAbbrev, logoUrlFromName } from '../../utils/teamLogos';

const SIZE_CLASSES = {
  xs: 'w-4 h-4', // 16px — dense tables
  sm: 'w-5 h-5', // 20px — compact rows
  md: 'w-6 h-6', // 24px — standard cards
  lg: 'w-10 h-10', // 40px — scoreboard
};

interface TeamLogoProps {
  /** Team abbreviation (e.g. "NYY"). Takes priority over name. */
  abbrev?: string;
  /** Full team name (e.g. "New York Yankees"). Used when abbrev is unavailable. */
  name?: string;
  /** Sport league id — 'mlb' | 'nba' | 'wnba' | 'nfl'. Defaults to 'mlb'. */
  leagueId?: string;
  size?: keyof typeof SIZE_CLASSES;
  className?: string;
}

export function TeamLogo({ abbrev, name, leagueId = 'mlb', size = 'md', className = '' }: TeamLogoProps) {
  if (!abbrev && !name) return null;
  const src = abbrev ? logoUrlFromAbbrev(abbrev, leagueId) : logoUrlFromName(name!, leagueId);
  const alt = abbrev ?? name ?? '';

  return (
    <img
      src={src}
      alt={alt}
      className={`${SIZE_CLASSES[size]} object-contain flex-shrink-0 ${className}`}
      onError={(e) => {
        (e.currentTarget as HTMLImageElement).style.display = 'none';
      }}
    />
  );
}
